export enum GradeEnum {
  PRIME = 'Prime',
  GRADE_A = 'GradeA',
  GRADE_B = 'GradeB',
  GRADE_C = 'GradeC',
  OTHER = 'Other',
}
